module.exports = __webpack_public_path__ + "static/img/JCI_acceptance.77a791c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/JCI_acceptance.png
// module id = 5t6p
// module chunks = 1